import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64bcb43a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-slot-by-day-child" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "time-slot-by-day-child__range" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-64bcb43a><g clip-path=\"url(#clip0_3503_3256)\" data-v-64bcb43a><path d=\"M8 16C12.4172 16 16 12.4172 16 8C16 3.58285 12.4172 0 8 0C3.58285 0 0 3.58285 0 8C0 12.4172 3.58285 16 8 16ZM7.42855 3.42858C7.42855 3.11428 7.6857 2.85713 8 2.85713C8.3143 2.85713 8.57145 3.11428 8.57145 3.42858V7.72572L11.2143 9.84001C11.46 10.0372 11.5 10.3971 11.3029 10.6429C11.1914 10.7829 11.0257 10.8571 10.8571 10.8571C10.7314 10.8571 10.6057 10.8171 10.5 10.7314L7.64288 8.44573C7.50859 8.33714 7.4286 8.1743 7.4286 8V3.42858H7.42855Z\" fill=\"#3B82F6\" data-v-64bcb43a></path></g><defs data-v-64bcb43a><clipPath id=\"clip0_3503_3256\" data-v-64bcb43a><rect width=\"16\" height=\"16\" fill=\"white\" data-v-64bcb43a></rect></clipPath></defs></svg>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_slot_by_day_resources = _resolveComponent("time-slot-by-day-resources")!
  const _component_time_slot_by_day_sectors = _resolveComponent("time-slot-by-day-sectors")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, _toDisplayString(_ctx.getPeriod(_ctx.format(_ctx.item.timeFrom), _ctx.format(_ctx.item.timeTo))), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["range__status", { 'status--active': _ctx.item.status.id === 51, 'status--inactive': _ctx.item.status.id === 52 }])
        }, [
          (_ctx.item.status.id === 51)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Активный")
              ], 64))
            : (_ctx.item.status.id === 52)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("Неактивный")
                ], 64))
              : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createVNode(_component_time_slot_by_day_resources, {
      class: "mt-5",
      usage: _ctx.item.usage,
      resources: _ctx.item.capacities
    }, null, 8, ["usage", "resources"]),
    _createVNode(_component_time_slot_by_day_sectors, {
      class: "mt-5",
      sectors: _ctx.item.sectors
    }, null, 8, ["sectors"])
  ]))
}